import * as React from "react";
import { observer } from "mobx-react";
import { FlightsProps, FlightsState } from "./typings";
import { FlightFareTable } from "components/flexComponents/Flights/components/FlightFareTable";
import { FlightsViews, TripType } from "components/flexComponents/Flights/util/typings";
import { UitkSpacing } from "@egds/react-core/spacing";
import { FlightsFlexModuleResult } from "typings/microserviceModels/flights-flex-module";
import { withStores } from "stores";
import { FlightBarChartView } from "components/flexComponents/Flights/components/FlightBarChart/FlightBarChartView";
import { FlightsView } from "components/flexComponents/Flights/components/FlightsView";
import { IntersectionTracker } from "@shared-ui/clickstream-analytics-context";

@observer
export class Flights extends React.Component<FlightsProps, FlightsState> {
  private readonly model: FlightsFlexModuleResult | null;

  constructor(props: FlightsProps) {
    super(props);
    const { templateComponent, flexModuleModelStore } = this.props;
    this.model = flexModuleModelStore.getModel(templateComponent.metadata.id) as FlightsFlexModuleResult | null;
    if (!this.model || isFlightsElementsEmpty(this.model)) {
      return;
    }
    this.state = {
      flights: this.model.flights,
    };
  }

  private getFlightsView = (model: FlightsFlexModuleResult, id: string) => {
    switch (model.view) {
      case FlightsViews.FARE_TABLE:
        const roundTripFlights = this.state.flights.filter((flight) => {
          return flight.tripType === TripType.ROUND_TRIP;
        });

        return <FlightFareTable flights={roundTripFlights} />;
      case FlightsViews.BAR_CHART:
        return <FlightBarChartView title={model.title} id={id} fareCalendar={model.fareCalendar} />;
      default:
        return <FlightsView model={model} id={id} />;
    }
  };

  render() {
    if (!this.model || isFlightsElementsEmpty(this.model)) {
      return null;
    }
    const {
      metadata: { id },
      config,
    } = this.props.templateComponent;
    const { fmId, fmTitleId } = config;

    return (
      <IntersectionTracker
        trackOnce
        linkName="Flights module has been seen"
        referrerId={`Flights.${this.model.view}.${this.model.strategy}.Impression`}
      >
        <UitkSpacing padding={{ block: "six" }}>
          <div className="Flights" id={id} data-fm={fmId} data-fm-title-id={fmTitleId}>
            {this.getFlightsView(this.model, id)}
          </div>
        </UitkSpacing>
      </IntersectionTracker>
    );
  }
}

const isFlightsElementsEmpty = (model: FlightsFlexModuleResult) => {
  if (model.view === FlightsViews.BAR_CHART) {
    return !model.fareCalendar || model.fareCalendar.length === 0;
  }
  return !model.flights || model.flights.length === 0;
};

export default withStores("flexModuleModelStore")(Flights);
